export const BUTTON_HTML_TYPE = {
  button: 'button',
  submit: 'submit',
  reset: 'reset',
} as const;

export const BUTTON_VARIANT = {
  primary: 'primary',
  secondary: 'secondary',
  label: 'label',
} as const;

export const THROTTLE_TIME = 250;
